import { render, staticRenderFns } from "./ProfileHeader.vue?vue&type=template&id=0ceef63c&scoped=true"
import script from "./ProfileHeader.vue?vue&type=script&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&lang=js"
import style0 from "./ProfileHeader.vue?vue&type=style&index=0&id=0ceef63c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceef63c",
  null
  
)

export default component.exports